function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import { withStyles } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Drawer.styles';
var propTypes = {
  /** Controls whether the drawer is open or collapsed */
  open: PropTypes.bool.isRequired,

  /** Drawer content */
  children: PropTypes.node.isRequired,

  /** Optional className for styling */
  className: PropTypes.string,

  /* eslint-disable react/no-unused-prop-types */
  // used by styles

  /** Side of the screen to anchor the drawer to */
  anchorTo: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** Duration of the expand animation */
  expandDuration: PropTypes.number,

  /** Duration of the collapse animation */
  collapseDuration: PropTypes.number,

  /** The animation transition timing function value */
  transitionMode: PropTypes.string,

  /** Size (height or width based on anchorTo value) of content when expanded */
  size: PropTypes.number,

  /** Size of content when collapsed (width to animate from) */
  startingSize: PropTypes.number,

  /** Internal classes hash - do not pass */
  classes: PropTypes.shape({}).isRequired
};
var defaultProps = {
  anchorTo: 'left',
  className: undefined,
  expandDuration: 0.5,
  collapseDuration: 0.3,
  transitionMode: 'ease-in-out',
  size: 350,
  startingSize: 0
};

var Drawer = function Drawer(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      open = _ref.open,
      className = _ref.className;
  return React.createElement("div", {
    className: classNames(classes.root, className, _defineProperty({}, classes.open, open))
  }, React.createElement("div", {
    className: classNames(classes.content)
  }, children));
};

Drawer.propTypes = propTypes;
Drawer.defaultProps = defaultProps;
export var DrawerBase = Drawer;
export default withStyles(styles)(Drawer);